import { z } from "zod";

export const getSivDataCarIconsByStatusRequestSchema = z.object({
  status: z.enum(["TO_REVIEW", "VALIDATED", "NOT_FOUND", "REJECTED"]),
});

export type GetSivDataCarIconsByStatusRequest = z.infer<
  typeof getSivDataCarIconsByStatusRequestSchema
>;
